import { CropAction } from '@/models/cropGuide'

import { get } from '../axios'

const getCropActions = (cropId: number, lang: string, sowingDate?: string) =>
  get<CropAction[]>(`/khetibook/v1/crop-actions/${cropId}`, {
    lang,
    sowing_time: sowingDate,
  })

export default getCropActions
